import { Component, OnDestroy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid';

export interface InfoHeaderParams extends IHeaderParams {
  onInfoClick?: () => void;
  infoTitle?: string;
}

@Component({
  selector: 'app-info-header',
  templateUrl: './info-header.component.html',
  styleUrls: ['./info-header.component.scss']
})
export class InfoHeaderComponent implements IHeaderAngularComp, OnDestroy {
  params: InfoHeaderParams;
  sort = '';
  private sortChangedHandler = this.onSortChanged.bind(this);

  agInit(params: InfoHeaderParams): void {
    this.params = params;
    if (params && params.column) {
      params.column.addEventListener('sortChanged', this.sortChangedHandler);
      this.onSortChanged();
    }
  }

  ngOnDestroy(): void {
    if (this.params && this.params.column) {
      this.params.column.removeEventListener('sortChanged', this.sortChangedHandler);
    }
  }

  get infoTitle(): string {
    return this.params && this.params.infoTitle ? this.params.infoTitle : 'What does this column mean?';
  }

  get infoClickable(): boolean {
    return !!(this.params && this.params.onInfoClick);
  }

  onSortChanged(): void {
    this.sort = this.params.column.getSort() || '';
  }

  onSortRequested(event: MouseEvent): void {
    if (this.params && this.params.enableSorting) {
      this.params.progressSort(event.shiftKey);
    }
  }

  onInfoClicked(event: MouseEvent): void {
    event.stopPropagation();
    if (this.params && this.params.onInfoClick) {
      this.params.onInfoClick();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/info-header/info-header.component.ts